import { API, Card } from '@enkla-gui'
import React from 'react'
import { notify } from '@/_helpers'

export default function RentalBlockStatus({ entity, refetch }) {
  const block = entity?.rental_block

  if (!block) return null

  const end = () => {
    API.delete(`api/entity/${entity.id}/rental-block`)
      .then(() => {
        notify.toast('Uthyrningsstoppet har tagits bort och objektet kan hyras ut igen')
        refetch && refetch()
      })
      .catch(([err, res]) => {
        notify.toast(typeof res === 'string' ? res : res?.message || 'Kunde inte ta bort uthyrningsstoppet', 'error')
      })
  }

  return (
    <div class='component_RentalBlockStatus mb-15'>
      <Card
        title='Objektet har uthyrningsstopp'
        collapsed={null}
        icon='fas fa-fw fa-pause'
        buttons={{
          footer: [{ text: 'Ta bort uthyrningsstopp', bg: 'warning', callback: end }]
        }}>
        <div class='row'>
          <div class='col'>
            <div class='form-group'>
              <textarea rows={6} disabled type='text' style={{ background: 'rgb(248, 248, 251)' }} class='form-control form-control-input ' value={block.reason} />
              <label class='label-control'>Anledning</label>
            </div>
          </div>
        </div>
      </Card>
    </div>
  )
}
